import './App.css';
import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useSwipeable } from 'react-swipeable';
import * as motion from "motion/react-client"
import Navigation from './Navigation';
import Main from './Main';
import Page from './Page';
import Contacts from './Contacts';
import Preview from './Preview';
import ImageMyWeek from './Images/MyWeek.png';
import ImageSmart from './Images/Smart.png';
import ImageBeautiful from './Images/Beautiful.png';
import ImageJoyful from './Images/Joyful.png';
import ImageDaruma from './Images/Daruma.png';



const textMain =
<div className='text-wrapper'>
  <p className='text main'>
    My Week is a design experiment<span className='text secondary'>*</span> about noticing.
  </p>
  <p className='text main'>
    What do my daily actions add up to?
  </p>
  <p className='text main'>
    To make it visible, I pick a few areas of life and think about what I do to be smart or to look better every week.
  </p>
  <p className='text secondary'>
    *Desktop + mobile web application. Works with an invitation.
  </p>
</div>
;

// Smart page content

const textSmart =
<div className='text-wrapper'>
  <p className='text main'>
    This page is for everything that adds to the intellectual area.
  </p>
  <p className='text main'>
    It may be learning a new language, reading a book, or solving dilemmas. Anything.
  </p>
</div>
;

const noteSmart =
<div className='text-wrapper'>
  <p className='text secondary'>
    Plan something that makes you a smarter version of yourself. If needed, change the list.
  </p>
</div>
;

// Beautiful page content

const textBeautiful =
<div className='text-wrapper'>
  <p className='text main'>
    This page answers the question, “What do I do to feel better and live better in my body?”
  </p>
  <p className='text main'>
    Some ideas: yoga, healthy food, taking walks, massage, me time.
  </p>
</div>
;

const noteBeautiful =
<div className='text-wrapper'>
  <p className='text secondary'>
    Decide what you can do for your body. Follow the plan. Not enough time? Change the list.
  </p>
</div>
;

// Joyful page content

const textJoyful =
<div className='text-wrapper'>
  <p className='text main'>
    The list of joyful moments is for everything that adds to your happiness.
  </p>
  <p className='text main'>
    Why this way? I believe we cannot plan positive emotions. One can create a perfect space for it but feel tired or frustrated.
  </p>
</div>
;

const noteJoyful =
<div className='text-wrapper'>
  <p className='text secondary'>
    Write down any moment you’re thankful for.
  </p>
</div>
;

// Daruma page content

const textDaruma =
<div className='text-wrapper'>
  <p className='text main'>
    Daruma is an additional page.
  </p>
</div>
;

const noteDaruma =
<div className='text-wrapper'>
  <p className='text secondary'>
    Daruma is a Japanese good-luck doll.
  </p>
  <p className='text secondary'>
    The owner paints one eye when setting a goal. The second eye is painted when the goal is achieved.
  </p>
</div>
;

// Contacts page content

const textContacts =
<div className='text-wrapper'>
  <p className='text main'>
    Marina.
  </p>
  <a className='text link' href="mailto:murmurpaw@gmail.com">Murmurpaw@gmail.com</a>
</div>
;

const linksContacts =
<div className='text-wrapper'>
  <p><a className='text link' href="https://my-week-tracker.web.app">My Week App</a></p>
  <p><a className='text link' href="https://marina-re.framer.website">Marina-re.framer.website</a></p>
</div>
;



function App() {

  const isMobile = useMediaQuery({ query: `(max-width: 1132px)` });

  const [isTransition, setIsTransition] = useState(false);

  const handleTransition = () => {
    setIsTransition(true);
    console.log(isTransition);
    cleanTransition();
  }

  const cleanTransition = () => {
    setTimeout(() => {
      setIsTransition(false);
    }, 600);
  };

  const handlers = useSwipeable({
    onSwipedUp: () => handleScrollForward(),
    onSwipedDown: () => handleScrollBack(),
    swipeDuration: 500,
    // preventScrollOnSwipe: true, // Prevents page scrolling during gesture
    trackMouse: true // Optional: allows mouse dragging to simulate swipe
  });

  const handleScrollForward= () => {
    if (isMobile) {if (currentPage === 'My Week') {setCurrentPage('Smart'); handleTransition()}
    else if (currentPage === 'Smart') {setCurrentPage('Beautiful'); handleTransition()}
    else if (currentPage === 'Beautiful') {setCurrentPage('Joyful'); handleTransition()}
    else if (currentPage === 'Joyful') {setCurrentPage('Daruma'); handleTransition()}
    else if (currentPage === 'Daruma') {setCurrentPage('Contacts'); handleTransition()}
    else {return null}} else {
      return null
    }
  }
  
  const handleScrollBack = () => {
    if (isMobile) {if (currentPage === 'My Week') {return null}
    else if (currentPage === 'Smart') {setCurrentPage('My Week'); handleTransition()}
    else if (currentPage === 'Beautiful') {setCurrentPage('Smart'); handleTransition()}
    else if (currentPage === 'Joyful') {setCurrentPage('Beautiful'); handleTransition()}
    else if (currentPage === 'Daruma') {setCurrentPage('Joyful'); handleTransition()}
    else if (currentPage === 'Contacts') {setCurrentPage('Daruma'); handleTransition()}
    else {return null}} else {
      return null;
    }
  }

  const [currentPage, setCurrentPage] = useState('My Week');
  const [currentColor, setCurrentColor] = useState('rgba(232, 72, 42, 1');

  const handlePagination = (title, color) => {
    setCurrentPage(title);
    setCurrentColor(color);
  }

  const [previewDisplay, setPreviewDisplay] = useState('none')
  const [previewImage, setPreviewImage] = useState(null)

  const handlePreview = (image) => {
    setPreviewDisplay('flex');
    setPreviewImage(image);
  }

  const handleClosePreview = () => {
    setPreviewDisplay('none');
    setPreviewImage(null);
  }


  return (
    <div className='container'>
      <div
      className={isTransition ? 'transition animate' : 'transition'}
      style={{
        display: isMobile ? 'block' : 'none',
        pointerEvents: 'none',
        position: 'absolute',
        top: '83px',
        bottom: '-10px',
        left: '-10px',
        right: '-10px',
      }}
      />
      <Preview onClick={handleClosePreview} display={previewDisplay} image={previewImage} />
      <div className='column-1'><Navigation navigateBack={handleScrollBack} navigateForward={handleScrollForward} currentPage={currentPage} currentColor={currentColor} handlePagination={handlePagination}/></div>
      <div className='column-2'>
        <Main onClick={() => handlePreview(ImageMyWeek)} text={textMain} image={ImageMyWeek} isCurrent={currentPage === 'My Week' ? true : false}/>
        <Page onClick={() => handlePreview(ImageSmart)} text={textSmart} note={noteSmart} image={ImageSmart} isCurrent={currentPage === 'Smart' ? true : false}></Page>
        <Page onClick={() => handlePreview(ImageBeautiful)} text={textBeautiful} note={noteBeautiful} image={ImageBeautiful} isCurrent={currentPage === 'Beautiful' ? true : false}></Page>
        <Page onClick={() => handlePreview(ImageJoyful)} text={textJoyful} note={noteJoyful} image={ImageJoyful} isCurrent={currentPage === 'Joyful' ? true : false}></Page>
        <Page onClick={() => handlePreview(ImageDaruma)} text={textDaruma} note={noteDaruma} image={ImageDaruma} isCurrent={currentPage === 'Daruma' ? true : false}></Page>
        <Contacts text={textContacts} links={linksContacts} isCurrent={currentPage === 'Contacts' ? true : false}></Contacts>
      </div>
    </div>
  );
}

export default App